import React from "react";
import SidebarMenuItems from "./SidebarMenuItems";

const SidebarMenu = ({ collapsed }) => (
  <nav style={{ width: "100%", flex: 1, overflowY: "auto", overflowX: "hidden" }}>
    <SidebarMenuItems collapsed={collapsed} />
  </nav>
);

export default SidebarMenu;
